import { CoreDomainSearchStore, DomainSearchSuiteModule } from '@wix/domains-search-suite';
import { isValidDomain } from '@wix/domains-serverless-interface';
import { useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { useQueryParams } from './useQueryParams';
export const useQuerySubmit = _ref => {
  let {
    path = '/results'
  } = _ref;
  const ref = useRef(false);
  const {
    getQueryParam
  } = useQueryParams();
  const {
    recoverFromUrl,
    getUrlState
  } = DomainSearchSuiteModule.SDK.hooks.useUrlRecovery();
  const history = useHistory();
  useEffect(() => {
    var _CoreDomainSearchStor;
    if (ref.current) {
      return;
    }
    ref.current = true;
    const {
      query: queryFromUrl,
      tlds,
      keywords,
      style
    } = recoverFromUrl();

    // Store is not empty
    if ((_CoreDomainSearchStor = CoreDomainSearchStore.getStore()) != null && _CoreDomainSearchStor.query) {
      return;
    }

    // To preserve concierge deeplinks
    const domainName = getQueryParam('domainName');
    const query = domainName ?? queryFromUrl;
    if (!query) {
      return;
    }
    CoreDomainSearchStore.setTlds(tlds ?? []);
    CoreDomainSearchStore.setQuery(query);
    CoreDomainSearchStore.setStyle(style ?? '');
    CoreDomainSearchStore.setKeywords(keywords ?? []);
    if (isValidDomain(query)) {
      CoreDomainSearchStore.setSubmittedDomain(query);
    } else {
      CoreDomainSearchStore.setSubmittedDomain(undefined);
    }
    CoreDomainSearchStore.setSubmittedFilters({
      query,
      tlds: tlds ?? [],
      keywords: keywords ?? [],
      style: style ?? ''
    });
    history.replace(`${path}?${getUrlState({
      query,
      tlds,
      keywords,
      style
    })}`);
  }, [history, recoverFromUrl, getUrlState, getQueryParam, path]);
};
//# sourceMappingURL=useQuerySubmit.js.map